import React from 'react';
import { Link } from 'react-router-dom';
import styles from './StatusPage.module.css';
import { ShieldOff } from 'lucide-react';

const UnauthorizedPage: React.FC = () => {
    return (
        <div className={styles.statusPageContainer}>
            <div className={styles.contentWrapper}>
                <div className={styles.iconWrapper} style={{ backgroundColor: '#fef2f2', color: '#ef4444' }}>
                    <ShieldOff size={64} strokeWidth={1.5} />
                </div>
                <h1 className={styles.title}>Acceso Denegado</h1>
                <p className={styles.subtitle}>No tienes permiso para ver esta página.</p>
                <p className={styles.description}>
                    Por favor, contacta al administrador del sistema si crees que esto es un error.
                </p>
                <Link to="/dashboard" className={styles.actionButton}>
                    Volver al Dashboard
                </Link>
            </div>
        </div>
    );
};

export default UnauthorizedPage;